import React from 'react';
import './style.scss';

export default class EducationSelecter extends React.Component {
	education = ["Select","Secondary School",
      "Higher Secondary School",
      "Associate Degree in Administration of Justice",
      "Associate Degree in Advertising",
      "Associate Degree in Agribusiness",
      "Associate Degree in Animal Management",
      "Associate Degree in Architectural Building Engineering Technology",
      "Associate Degree in Architecture and Career Options",
      "Associate Degree in Art",
      "Associate Degree in Automotive Maintenance Technology",
      "Associate Degree in Aviation Mechanics",
      "Associate Degree in Behavioral Science",
      "Associate Degree in Boat Mechanics",
      "Associate Degree in Boat Repair and Maintenance",
      "Associate Degree in Cabinet Design Technology",
      "Associate Degree in Child Development: Program Summary",
      "Associate Degree in Christian Ministry",
      "Associate Degree in Cosmetology Business",
      "Associate Degree in Digital Media",
      "Associate Degree in Early Childhood Special Education",
      "Associate Degree in Elementary Education",
      "Associate Degree in English",
      "Associate Degree in Environmental Science",
      "Associate Degree in Environmental Studies",
      "Associate Degree in General Psychology",
      "Associate Degree in History and Information",
      "Associate Degree in Interdisciplinary Studies",
      "Associate Degree in International Relations",
      "Associate Degree in Landscape Architecture",
      "Associate Degree in Landscaping Design",
      "Associate Degree in Library Science",
      "Associate Degree in Music",
      "Associate Degree in Wildlife Management",
      "Associate Degree in Education",
      "Associate of Applied Science (AAS) in Accelerated Culinary Arts",
      "Associate of Applied Science (AAS) in Accounting Specialist",
      "Associate of Applied Science (AAS) in Administrative Support",
      "Associate of Applied Science (AAS) in Baking and Pastry",
      "Associate of Applied Science (AAS) in Business Administration",
      "Associate of Applied Science (AAS) in Business Administration - Finance",
      "Associate of Applied Science (AAS) in Business Information Systems",
      "Associate of Applied Science (AAS) in Civil Justice - Law Enforcement",
      "Associate of Applied Science (AAS) in Clinical Medical Assisting",
      "Associate of Applied Science (AAS) in Computer Applications",
      "Associate of Applied Science (AAS) in Computer Electronics",
      "Associate of Applied Science (AAS) in Computer Game Design",
      "Associate of Applied Science (AAS) in Computer Information Systems",
      "Associate of Applied Science (AAS) in Culinary Arts",
      "Associate of Applied Science (AAS) in Digital Media Communications",
      "Associate of Applied Science (AAS) in Digital Photography",
      "Associate of Applied Science (AAS) in Electronic Engineering",
      "Associate of Applied Science (AAS) in Emergency Medical Services",
      "Associate of Applied Science (AAS) in Health Care Management",
      "Associate of Applied Science (AAS) in Health Information Management",
      "Associate of Applied Science (AAS) in Healthcare Administration",
      "Associate of Applied Science (AAS) in Legal Office E-ministration",
      "Associate of Applied Science (AAS) in Telecommunications Technology",
      "Associate of Applied Science (AAS) in Television Production",
      "Associate of Applied Science (AAS) in Visual Communications",
      "Associate of Arts (AA) in Computer Information Systems",
      "Associate of Arts (AA) in Internetworking Technology",
      "Associate of Arts (AA) in Psychology",
      "Associate of Arts (AA) in Interior Architecture and Design",
      "Associate of Biotechnology",
      "Associate of Business Science (ABS) in Individualized Studies",
      "Associate of Early Childhood Education (AECE)",
      "Associate of Occupational Studies (AOS) in Legal Office Administration",
      "Associate of Science (AS) in Computer Information Science",
      "Associate of Science (AS) in Computer Science",
      "Associate of Science (AS) in Corrections, Probation, &amp; Parole",
      "Associate of Science (AS) in Electronics Engineering Technology",
      "Associate of Science (AS) in Interactive &amp; Graphic Art",
      "Associate of Science (AS) in Industrial Maintenance Technology",
      "Associate of Arts and science",
      "Bachelor degrees",
      "Bachelor of Science in Genetic Engineering and Biotechnology",
      "Bachelor of Architecture",
      "Bachelor of Biomedical Science",
      "Bachelor of Business Administration",
      "Bachelor of Clinical Science",
      "Bachelor of Commerce",
      "Bachelor of Computer Applications",
      "Bachelor of Community Health",
      "Bachelor of Computer Information Systems",
      "Bachelor of Science in Construction Technology",
      "Bachelor of Criminal Justice",
      "Bachelor of Divinity",
      "Bachelor of Economics",
      "Bachelor of Education",
      "Bachelor of Engineering",
      "Bachelor of Fine Arts",
      "Bachelor of Letters",
      "Bachelor of Information Systems",
      "Bachelor of Management",
      "Bachelor of Music",
      "Bachelor of Pharmacy",
      "Bachelor of Philosophy",
      "Bachelor of Social Work",
      "Bachelor of Technology",
      "Bachelor of Accountancy",
      "Bachelor of Arts in American Studies",
      "Bachelor of Arts in American Indian Studies",
      "Bachelor of Arts in Applied Psychology",
      "Bachelor of Arts in Biology",
      "Bachelor of Arts in Anthropology",
      "Bachelor of Arts in Child Advocacy",
      "Bachelor of Arts in Clinical Psychology",
      "Bachelor of Arts in Forensic Psychology",
      "Bachelor of Arts in Organizational Psychology",
      "Bachelor of Science in Aerospace Engineering",
      "Bachelor of Science in Actuarial",
      "Bachelor of Science in Agriculture",
      "Bachelor of Science in Architecture",
      "Bachelor of Science in Architectural Engineering",
      "Bachelor of Science in Athletic Training",
      "Bachelor of Science in Biology",
      "Bachelor of Science in Biomedical Engineering",
      "Bachelor of Science in Bible",
      "Bachelor of Science in Business Administration",
      "Bachelor of Science in Business and Technology",
      "Bachelor of Science in Chemical Engineering",
      "Bachelor of Science in Chemistry",
      "Bachelor of Science in Civil Engineering",
      "Bachelor of Science in Clinical Laboratory Science",
      "Bachelor of Science in Cognitive Science",
      "Bachelor of Science in Computer Engineering",
      "Bachelor of Science in Computer Science",
      "Bachelor of Science in Construction Engineering",
      "Bachelor of Science in Construction Management",
      "Bachelor of Science in Criminal Justice",
      "Bachelor of Science in Criminology",
      "Bachelor of Science in Diagnostic Radiography",
      "Bachelor of Science in Education",
      "Bachelor of Science in Electrical Engineering",
      "Bachelor of Science in Engineering Physics",
      "Bachelor of Science in Engineering Science",
      "Bachelor of Science in Engineering Technology",
      "Bachelor of Science in English Literature",
      "Bachelor of Science in Environmental Engineering",
      "Bachelor of Science in Environmental Science",
      "Bachelor of Science in Environmental Studies",
      "Bachelor of Science in Food Science",
      "Bachelor of Science in Foreign Service",
      "Bachelor of Science in Forensic Science",
      "Bachelor of Science in Forestry",
      "Bachelor of Science in History",
      "Bachelor of Science in Hospitality Management",
      "Bachelor of Science in Human Resources Management",
      "Bachelor of Science in Industrial Engineering",
      "Bachelor of Science in Information Technology",
      "Bachelor of Science in Information Systems",
      "Bachelor of Science in Integrated Science",
      "Bachelor of Science in International Relations",
      "Bachelor of Science in Journalism",
      "Bachelor of Science in Legal Management",
      "Bachelor of Science in Management",
      "Bachelor of Science in Manufacturing Engineering",
      "Bachelor of Science in Marketing",
      "Bachelor of Science in Mathematics",
      "Bachelor of Science in Mechanical Engineering",
      "Bachelor of Science in Medical Technology",
      "Bachelor of Science in Metallurgical Engineering",
      "Bachelor of Science in Meteorology",
      "Bachelor of Science in Microbiology",
      "Bachelor of Science in Mining Engineering",
      "Bachelor of Science in Molecular Biology",
      "Bachelor of Science in Neuroscience",
      "Bachelor of Science in Nursing",
      "Bachelor of Science in Nutrition science",
      "Bachelor of Science in Software Engineering",
      "Bachelor of Science in Petroleum Engineering",
      "Bachelor of Science in Podiatry",
      "Bachelor of Science in Pharmacology",
      "Bachelor of Science in Pharmacy",
      "Bachelor of Science in Physical Therapy",
      "Bachelor of Science in Physics",
      "Bachelor of Science in Plant Science",
      "Bachelor of Science in Politics",
      "Bachelor of Science in Psychology",
      "Bachelor of Science in Public Safety",
      "Bachelor of Science in Physiology",
      "Bachelor of Science in Quantity Surveying Engineering",
      "Bachelor of Science in Radiologic Technology",
      "Bachelor of Science in Real-Time Interactive Simulation",
      "Bachelor of Science in Religion",
      "Bachelor of Science in Respiratory Therapy",
      "Bachelor of Science in Risk Management and Insurance",
      "Bachelor of Science in Science Education",
      "Bachelor of Science in Sports Management",
      "Bachelor of Science in Systems Engineering",
      "Bachelor of Music in Jazz Studies",
      "Bachelor of Music in Composition",
      "Bachelor of Music in Performance",
      "Bachelor of Music in Theory",
      "Bachelor of Music in Music Education",
      "Bachelor of Science in Veterinary Technology",
      "BBA- Bachelor of Business Administration",
      "BMS- Bachelor of Management Science",
      "BFA- Bachelor of Fine Arts",
      "BEM- Bachelor of Event Management",
      "Integrated Law Course- BA + LL.B",
      "BJMC- Bachelor of Journalism and Mass Communication",
      "BFD- Bachelor of Fashion Designing",
      "BSW- Bachelor of Social Work",
      "BBS- Bachelor of Business Studies",
      "BTTM- Bachelor of Travel and Tourism Management",
      "Aviation Courses",
      "B.Sc- Interior Design",
      "B.Sc.- Hospitality and Hotel Administration",
      "BVA- Bachelor of Visual Arts",
      "Bachelor of Performing Arts",
      "BA in History",
      "BE/B.Tech- Bachelor of Technology",
      "B.Arch- Bachelor of Architecture",
      "BCA- Bachelor of Computer Applications",
      "B.Sc.- Information Technology",
      "B.Sc- Nursing",
      "BPharma- Bachelor of Pharmacy",
      "B.Sc- Interior Design",
      "BDS- Bachelor of Dental Surgery",
      "Animation, Graphics and Multimedia",
      "B.Sc. – Nutrition &amp; Dietetics",
      "BPT- Bachelor of Physiotherapy",
      "B.Sc- Applied Geology",
      "BA/B.Sc. Liberal Arts",
      "B.Sc.- Physics",
      "B.Sc. Chemistry",
      "B.Sc. Mathematics",
      "Aeronautical Engineering",
      "Automobile Engineering",
      "Civil Engineering",
      "Computer Science and Engineering",
      "Biotechnology Engineering",
      "Electrical and Electronics Engineering",
      "Electronics and Communication Engineering",
      "Automation and Robotics",
      "Petroleum Engineering",
      "Instrumentation Engineering",
      "Ceramic Engineering",
      "Chemical Engineering",
      "Structural Engineering",
      "Transportation Engineering",
      "Construction Engineering",
      "Power Engineering",
      "Robotics Engineering",
      "Textile Engineering",
      "Smart Manufacturing &amp; Automation",
      "B.Com- Bachelor of Commerce",
      "BBA- Bachelor of Business Administration",
      "B.Com (Hons.)",
      "BA (Hons.) in Economics",
      "Integrated Law Program- B.Com LL.B.",
      "Integarted Law Program- BBA LL.B",
      "CA- Chartered Accountancy",
      "CS- Company Secretary",
      "Bachelor of Design in Accessory Design, fashion Design, Ceramic Design, Leather Design, Graphic Design, Industrial Design, Jewellery Design",
      "Bachelor in Foreign Language",
      "Diploma Courses",
      "Advanced Diploma Courses",
      "Certificate Courses",
      "Master degrees",
      "Master of Accountancy",
      "Master of Accounting and Information Systems",
      "Master of Advanced Study",
      "Master of Applied Finance",
      "Master of Applied Mathematical Sciences",
      "Master of Applied Psychology",
      "Master of Applied Science",
      "Master of Architecture",
      "Master of Arts",
      "Master of Arts in Archives and Records Management",
      "Master of Arts in Bioethics",
      "Master of Arts in Liberal Studies",
      "Master of Arts in Museum Studies",
      "Master of Arts in Strategic Communication Management",
      "Master of Arts in Teaching",
      "Master of Athletic Training",
      "Master of Bioethics",
      "Master of Bioinformatics",
      "Master of Biotechnology",
      "Master of Business Administration",
      "Master of Business Administration Management of Technology",
      "Master of Business",
      "Master of Business Economics",
      "Master of Business Engineering",
      "Master of Business Informatics",
      "Master of Chemistry",
      "Master of City Planning",
      "Master of Commerce",
      "Master of Community Health",
      "Master of Computational Finance",
      "Master of Computer Applications",
      "Master of Computer Science",
      "Master of Communication",
      "Master of Counselling (or Counseling)",
      "Master of Criminal Justice",
      "Master in Creative Technologies",
      "Master of Design",
      "Master of Divinity",
      "Master of Economics",
      "Master of Education",
      "Master of Educational Technology",
      "Master of Engineering",
      "Master of Engineering Management",
      "Master of Enterprise",
      "Master of European Law",
      "Master of Finance",
      "Master of Financial Economics",
      "Master of Financial Engineering",
      "Master of Financial Mathematics",
      "Master of Fine Arts",
      "Master of Geospatial Science &amp; Technology",
      "Master of Health Administration",
      "Master of Health Science",
      "Master of Humanities",
      "Master of Industrial and Labor Relations",
      "Master of International Affairs",
      "Master of International Business",
      "Master of International Economics",
      "Master of International Public Policy",
      "Master of International Studies",
      "Master of Information",
      "Master of Information Management",
      "Master of Information Systems",
      "Master of Information System Management",
      "Master of Islamic Studies",
      "Master of IT",
      "Master of Jurisprudence",
      "Master of Laws",
      "Master of Studies in Law",
      "Master of Landscape Architecture",
      "Master of Letters",
      "Master of Liberal Arts",
      "Master of Library and Information Science",
      "Master of Management",
      "Master of Mass Communication and Journalism",
      "Master of Mathematical Finance",
      "Master of Mathematics",
      "Master of Mathematics and Computer Science",
      "Master of Mathematics and Philosophy",
      "Master of Medical Science",
      "Master of Medicine",
      "Master of Military Art and Science",
      "Master of Music",
      "Master of Network and Communications Management",
      "Master of Occupational Therapy",
      "Master of Pharmacy",
      "Master of Philosophy",
      "Master of Physician Assistant Studies",
      "Master of Physics",
      "Master of Political Science",
      "Master of Professional Studies",
      "Master of Psychology",
      "Master of Public Administration",
      "Master of Public Affairs",
      "Master of Public Diplomacy",
      "Master of Public Health",
      "Master of Public Management",
      "Master of Public Policy",
      "Master of Public Relations",
      "Master of Public Service",
      "Master of Quantitative Finance",
      "Master of Rabbinic Studies",
      "Master of Real Estate Development",
      "Master of Religious Education",
      "Master of Research",
      "Master of Sacred Music",
      "Master of Sacred Theology",
      "Master of Science",
      "Master of Science in Applied Cognition and Neuroscience",
      "Master of Science in Athletic Training",
      "Master of Science in Bioinformatics",
      "Master of Science in Business Analytics",
      "Master of Science in Clinical Epidemiology",
      "Master of Science in Computing Research",
      "Master of Science in Cyber Security",
      "Master of Science in Education",
      "Master of Science in Engineering",
      "Master of Science in Development Administration",
      "Master of Science in Finance",
      "Master of Science in Governance &amp; Organizational Sciences",
      "Master of Science in Government Contracts",
      "Master of Science in Health Informatics",
      "Master of Science in Human Resource Development",
      "Master of Science in Information Assurance",
      "Master of Science in Information Systems",
      "Master of Science in Information Technology",
      "Master of Science in Leadership",
      "Master of Science in Management",
      "Master of Science in Nursing",
      "Master of Science in Project Management",
      "Master of Science in Quality Assurance",
      "Master of Science in Risk Management",
      "Master of Science in Supply Chain Management",
      "Master of Science in Teaching",
      "Master of Science in Taxation",
      "Master of Social Science",
      "Master of Social Work",
      "Master of Statistics",
      "Master of Strategic Studies",
      "Master of Studies",
      "Master of Surgery",
      "Master of Theological Studies",
      "Master of Technology",
      "Master of Theology",
      "Master of Urban Planning",
      "Master of Veterinary Science",
      "Doctoral degrees",
      "Doctor of Arts",
      "Doctor of Audiology",
      "Doctor of Aviation (Av.D.)",
      "Doctor of Business Administration",
      "Doctor of Canon Law",
      "Doctor of Chiropractic",
      "Doctor of Commerce",
      "Doctor of Community Health",
      "Doctor of Dental Surgery",
      "Doctor of Divinity",
      "Doctor of Education",
      "Doctor of Engineering",
      "Doctor of Fine Arts",
      "Doctor of Health Administration",
      "Doctor of Health Science",
      "Doctor of Juridical Science; Juris Doctor",
      "Doctor of Law; Legum Doctor",
      "Doctor of Liberal Studies",
      "Doctor of Management",
      "Doctor of Medicine (M.D.)",
      "Doctor of Ministry",
      "Doctor of Modern Languages",
      "Doctor of Musical Arts",
      "Doctor of Naturopathic Medicine",
      "Doctor of Optometry",
      "Doctor of Osteopathic Medicine",
      "Doctor of Pharmacy",
      "Doctor of Philosophy",
      "Doctor of Public Administration",
      "Doctor of Science",
      "Doctor of Theology",
      "Doctor of Veterinary Medicine",
      "Doctor of Radio oncology"];

	render() {
		return (
			<select name={this.props.name} className="EducationSelecter" required={this.props.required} onChange={this.props.onChange}>
				{
					this.education.map((x) => {
						return (
							<option value={x}>
								{x}
							</option>
						)
					})
				}
			</select>
		);
	}
}